// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__hShW-","paginationContainer":"style_paginationContainer__RAad7"};